import {palette as mainPalette} from './palette.ts'
import {breakpoints, mediaQueries} from './mediaQueries.ts'
import ResetStyles from './reset.ts'
import {shadows} from './shadows.ts'
import {opacities} from './opacities.ts'
import {DefaultTheme} from 'styled-components'
import {typography} from './typography.ts'

const GlobalStyles = ResetStyles
export const spacing = 4

interface ThemeInterface {
    name: 'light'
    /*name: 'light' | 'dark'*/
    direction?: 'ltr' | 'rtl'
}

const getAppTheme = ({name}: ThemeInterface): DefaultTheme => {
    const palette = mainPalette[name]

    return {
        breakpoints,
        mediaQueries,
        palette,
        shadows,
        opacities,
        spacing,
        transition: 'ease-in-out 200ms',
        typography,
        zIndex: {
            modalOverlay: 10,
            modal: 11,
            dropdown: 12,
            tooltip: 13,
            // The notification work-context bar must stay above every app layer: the top of
            // the scale is `tooltip: 13` and ad-hoc escalations in features reach 14, so this
            // sits well clear of both. Prefer the host-claim API over raising this further.
            contextBar: 20
        }
    }
}

export {GlobalStyles, getAppTheme}
